module.exports = __webpack_public_path__ + "img/senior_manager_curr.d9e0e880.jpg";